import {CommonService} from "./common/commonService";

export class MapLayerService{

    static getAllLayers = () => (
        CommonService.list("/layers")
    )

    static getLayer = (id) => (
        CommonService.list("/layers/" + id)
    )

    static createMapLayer = (bean) => (
        CommonService.post("/layers/addMapLayer/", bean)
    )

    static editMapLayer = (id, bean) => (
        CommonService.update("/layers/editMapLayer/" + id, bean)
    )

    static deleteMapLayer = (id) => (
        CommonService.delete("/layers/deleteMapLayer/" + id)
    )

    static getLayerTypes = () => (
        CommonService.list("/layers/getLayerTypes")
    )

    static addLayerToMap = (bean) => (
        CommonService.post("/mapLayersinMap/addlayerToMap/" + bean)
    )

    static editLayerToMap = (compositeId) => (
        CommonService.update("/mapLayersinMap/editlayerToMap/" + compositeId)
    )

    static deleteLayerFromMap = (compositeId) => (
        CommonService.delete("/mapLayersinMap/deleteLayerFromMap/" + compositeId)
    )

}